import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class RemoveBeneficiaryError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('RemoveBeneficiaryError', ...args);
    }
}
export default RemoveBeneficiaryError;
